/* eslint-disable import/prefer-default-export */
import { DigitalSubmissionMeta, QuestionCaseSetting } from '../../redux/types';

export const filterOptOutSects = (
  settingsArr: QuestionCaseSetting[], dsms?: DigitalSubmissionMeta[],
) => {
  if (!dsms) {
    return settingsArr;
  }
  const ignoreSecIdMap = dsms.reduce((acc, cur) => {
    if (cur.isOptOut) {
      acc[cur.selectedSectionId] = true;
    }
    return acc;
  }, {} as Record<number, boolean>);
  return settingsArr.filter((s) => !ignoreSecIdMap[s.digitalSectionId]);
};
